export default [
  {
    login: 'nguyenthanhlong11',
    id: 55585285,
    node_id: 'MDQ6VXNlcjU1NTg1Mjg1',
    avatar_url: 'https://avatars.githubusercontent.com/u/55585285?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/nguyenthanhlong11',
    html_url: 'https://github.com/nguyenthanhlong11',
    followers_url: 'https://api.github.com/users/nguyenthanhlong11/followers',
    following_url:
      'https://api.github.com/users/nguyenthanhlong11/following{/other_user}',
    gists_url: 'https://api.github.com/users/nguyenthanhlong11/gists{/gist_id}',
    starred_url:
      'https://api.github.com/users/nguyenthanhlong11/starred{/owner}{/repo}',
    subscriptions_url:
      'https://api.github.com/users/nguyenthanhlong11/subscriptions',
    organizations_url: 'https://api.github.com/users/nguyenthanhlong11/orgs',
    repos_url: 'https://api.github.com/users/nguyenthanhlong11/repos',
    events_url:
      'https://api.github.com/users/nguyenthanhlong11/events{/privacy}',
    received_events_url:
      'https://api.github.com/users/nguyenthanhlong11/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'Piyawat007',
    id: 78316852,
    node_id: 'MDQ6VXNlcjc4MzE2ODUy',
    avatar_url: 'https://avatars.githubusercontent.com/u/78316852?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/Piyawat007',
    html_url: 'https://github.com/Piyawat007',
    followers_url: 'https://api.github.com/users/Piyawat007/followers',
    following_url:
      'https://api.github.com/users/Piyawat007/following{/other_user}',
    gists_url: 'https://api.github.com/users/Piyawat007/gists{/gist_id}',
    starred_url:
      'https://api.github.com/users/Piyawat007/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/Piyawat007/subscriptions',
    organizations_url: 'https://api.github.com/users/Piyawat007/orgs',
    repos_url: 'https://api.github.com/users/Piyawat007/repos',
    events_url: 'https://api.github.com/users/Piyawat007/events{/privacy}',
    received_events_url:
      'https://api.github.com/users/Piyawat007/received_events',
    type: 'User',
    site_admin: false,
  },
]
